module.exports = __webpack_public_path__ + "customer-general-info.47bc0728a1a1e2754dfde953f4cfb414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer-general-info.svg
// module id = 1134
// module chunks = 0